import { UrlConstants } from "../url.constants";
export class ApiResultConstants {
    static URL = UrlConstants.API_V2 + "Result";
}
